import React, { Suspense } from 'react';

// Reasonable code splitting within light-apply only
// Fallback for lazy loading
const LightApplyFallback = () => (
    <div
        style={{
            minHeight: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        読み込み中...
    </div>
);

// Lazy load only the heavy pages
export const LazyJapanResumePage = React.lazy(() => import('./resume/JapanResumePage'));
export const LazyJapanReviewPage = React.lazy(() => import('./review/JapanReviewPage'));

// Wrapper components with suspense
export const JapanResumePageWithSuspense = () => (
    <Suspense fallback={<LightApplyFallback />}>
        <LazyJapanResumePage />
    </Suspense>
);

export const JapanReviewPageWithSuspense = () => (
    <Suspense fallback={<LightApplyFallback />}>
        <LazyJapanReviewPage />
    </Suspense>
);

// Export all other components normally (they're already small)
export { default as LightApplyIndexPage } from './LightApplyIndexPage';
export { default as NameInputPage } from './contact-info/NameInputPage';
export { default as ContactDetailsPage } from './contact-info/ContactDetailsPage';
export { default as DateOfBirthPage } from './contact-info/DateOfBirthPage';
export { default as GenderPage } from './contact-info/GenderPage';
export { default as AddressPage } from './contact-info/AddressPage';
export { default as ScreenerQuestionsPage } from './questions/ScreenerQuestionsPage';
export { default as ScoutSettingPage } from './scout-setting/ScoutSettingPage';
export { default as LightApplyPostApplyPage } from './post-apply/LightApplyPostApplyPage';
export { default as LightApplyLayout } from './LightApplyLayout';
